// Types
import { AppDispatch, AppGetState } from 'types/RootState.types';

// Config
import {
  ANALYTICS_CREATE_ACCOUNT_DETAILS_NOT_SAVED,
  ANALYTICS_CREATE_ACCOUNT_DETAILS_NOT_SAVED_ORDER_NOT_LINKED,
  ANALYTICS_CREATE_ACCOUNT_ORDER_NOT_LINKED,
  ANALYTICS_CREATE_ACCOUNT_PAYMENT_CARD_NOT_SAVED,
  ANALYTICS_UPDATED_PRODUCT_PAYMENT_DATA,
  UPDATE_DELIVERY_OPTION_ANALYTICS,
} from '@constants/actionConstants';

export const triggerAnalyticsEvent = (type: string, payload = {}) => ({
  type,
  ...payload,
});

export const triggerAnalyticsForUncompletedActions =
  (uncompletedActions: string | string[]) => (dispatch: AppDispatch) => {
    if (uncompletedActions.includes('linkOrderToAccount') && uncompletedActions.includes('savePersonalDetails')) {
      dispatch(triggerAnalyticsEvent(ANALYTICS_CREATE_ACCOUNT_DETAILS_NOT_SAVED_ORDER_NOT_LINKED));
    } else if (uncompletedActions.includes('linkOrderToAccount')) {
      dispatch(triggerAnalyticsEvent(ANALYTICS_CREATE_ACCOUNT_ORDER_NOT_LINKED));
    } else if (uncompletedActions.includes('savePersonalDetails')) {
      dispatch(triggerAnalyticsEvent(ANALYTICS_CREATE_ACCOUNT_DETAILS_NOT_SAVED));
    } else if (uncompletedActions.includes('savePaymentCard')) {
      dispatch(triggerAnalyticsEvent(ANALYTICS_CREATE_ACCOUNT_PAYMENT_CARD_NOT_SAVED));
    }
  };

// TODO replace deliveryActions.setUpdatedProductAndPaymentAnalytics with this as they do almost exactly the same thing
export const orderFormProductAnalyticsUpdate =
  (
    paymentAnalytics: any,
    productAnalytics: {
      sku?: string;
    }[],
  ) =>
  async (dispatch: AppDispatch, getState: AppGetState) => {
    const { delivery: { deliveries = [], items = [] } = {} } = getState() ?? {};

    const updatedProductAnalytics = items.map((item: { id?: string; skuId?: string }) => {
      const matchedProduct = productAnalytics.find((product: { sku?: string }) => item?.skuId === product.sku);

      if (matchedProduct) {
        const delivery = deliveries.find((delivery) =>
          delivery?.items?.some((deliveryItem) => deliveryItem?.id === item?.id),
        );

        return {
          ...matchedProduct,
          batchNum: delivery?.id,
        };
      }

      return null;
    });

    dispatch({
      type: ANALYTICS_UPDATED_PRODUCT_PAYMENT_DATA,
      paymentAnalytics,
      productAnalytics: updatedProductAnalytics,
    });
  };

export const updateDeliveryOptionAnalytics = (response: any) => (dispatch: AppDispatch, getState: AppGetState) => {
  // when APO is enabled we update the jlData object so it matches what happens with non-APO
  // this could potentially be removed if someone could determine if these analytics are used by anyone
  const { result: { orderForm: { deliveries = [] } = {} } = {} } = response ?? {};

  if (deliveries.length !== 1) return;

  const { delivery: { deliveryOptions = {} } = {} } = getState() ?? {};

  const deliveryOptionsForAnalytics = ['uk'];
  if (deliveryOptions.clickCollectAvailable) deliveryOptionsForAnalytics.push('cc');
  if (deliveryOptions.collectPlusAvailable) deliveryOptionsForAnalytics.push('cp');

  dispatch(triggerAnalyticsEvent(UPDATE_DELIVERY_OPTION_ANALYTICS, { deliveryOptionsForAnalytics }));
};

export default triggerAnalyticsEvent;
